import { Redirect, Route } from 'react-router-dom'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

const PrivateRoute = ({ component, children, authPath, isAuthenticated, ...rest }) => (
  <Route
    {...rest}
    component={isAuthenticated ? (
      component
    ) : (
      authPath ? (
        ({ location }) => <Redirect to={{ pathname: authPath, state: { from: location } }}/>
      ) : null
    )
    }
  />
)

PrivateRoute.propTypes = {
  children: PropTypes.node,
  component: PropTypes.elementType,
  authPath: PropTypes.string,
  isAuthenticated: PropTypes.bool,
}

const mapStateToProps = ({ isAuthenticated }) => ({ isAuthenticated })

export default connect(mapStateToProps)(PrivateRoute)
